import React from 'react';

import ModuleWrapper from '@/modules/plan/ModuleWrapper';

import { PLAN_MODULES } from '../../plan.constants';

import EligibleServices from './EligibleServices';

interface Props {
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  isPlanActive?: boolean;
}

const EligibleServicesSection: React.FC<Props> = ({ isEditMode, isTemplateMode, isPlanActive }) => {
  return (
    <ModuleWrapper
      testId="eligible_services"
      anchorId={PLAN_MODULES.ELIGIBLE_SERVICES}
      title="Eligible Services"
      expandless
      defaultExpandedValue={false}
      subTitle="Eligible Services below reflect services available to participants when entering manual payments and reimbursements. To make changes to eligible payment card services contact your account manager."
      subTitleColor="textSecondary"
      subTitleBottomMargin="spacing12"
      contentRound="12px"
    >
      <EligibleServices isEditMode={isEditMode} isTemplateMode={isTemplateMode} isPlanActive={isPlanActive} />
    </ModuleWrapper>
  );
};

export default EligibleServicesSection;
